import service from './api.services';

const buscarPorId = async (idRegiao) => {
    const response = await service.get(`/api/regiao/${idRegiao}`);
    return response.data;
};


const cadastrarRegiao = async (data) => {
    await service.post('/api/regiao', data);
};

const deletar = async (idRegiao) => {
    const response = await service.delete(`/api/regiao/${idRegiao}`);
    return response;
};

const editarRegiao = async (data, idRegiao) => {
    await service.put(`/api/regiao/${idRegiao}`, data);
};

const listar = async (filtro) => {
    const response = await service.get('/api/regiao', { params: { ...filtro, pagina: filtro.pagina - 1 } });
    return response.data;
};

const regiaoGerentes = async (idRegiao) => {
    const response = await service.get(`/api/regiao/${idRegiao}/gerente-operacional`);
    return response.data;
};

const vincularGo = async (idRegiao, gerentesIds) => {
    const response = await service.post(`/api/regiao/${idRegiao}/gerente-operacional`, gerentesIds);
    return response;
};



export {
    buscarPorId,
    cadastrarRegiao,
    deletar,
    editarRegiao,
    listar,
    regiaoGerentes,
    vincularGo
};
